<template>
<div  v-bind:class="{ 'kyano-card-small col-6 col-sm-4': data.isSmallClass}">
  <v-card elevation="0" class="kyano-business-card card-style-1 mb-2" :to="data.to">
    <v-row class="card-content">
      <v-col cols="6"
        ><span class="card-logo"
          ><v-img
            class="mr-auto"
            max-width="50"
            width="50"
            max-height="20"
            src="../assets/kyano-logo-light.svg"
          ></v-img></span
      ></v-col>
      <v-spacer></v-spacer>
      <v-col cols="6">
        <div class="text-right">
          <span class="card-type">{{ data.card_type }}</span>
        </div>
      </v-col>
    </v-row>
    <v-spacer></v-spacer>
    <v-row class="card-content card-align-bottom">
      <v-col cols="9"
        ><span class="card-companyname">{{ data.companyname }}</span
        ><span class="card-profilename"
          >{{ data.profile_firstname }} {{ data.profile_lastname }}
        </span></v-col
      >
      <v-spacer></v-spacer>
      <v-col class="mt-auto text-right" cols="3"
        ><span class="card-nfc">
          <img
            class="ml-auto"
            max-width="25"
            width="25"
            max-height="35"
            src="../assets/nfc-icon.svg"
          />
        </span>
      </v-col>
    </v-row>
  </v-card>
  </div>
</template>
<script>
export default {
  props: {
    data: Object,
  },
};
</script>


<style>
.kyano-business-card.card-style-1 {
  background: #1c1c1e!important;
  position: relative!important;
  color: #fff!important;
  padding: 20px;  
  border-radius: 15px!important;
  width: 375px!important;
  height: 200px;
  overflow: hidden!important;
  max-width: 100%!important;
  margin: auto;
}

.kyano-business-card.card-style-1 .card-type {
  font-size: 13px;
  text-align: right;
}

.card-style-1:after {
  content: ""!important;
  position: absolute!important;
  left: 0!important;
  z-index: 1!important;
  top: 0!important;
  background-image: url("../assets/kyano-business-card-dark-pattern.svg")!important;
  background-position: center!important;
  width: 100%!important;
  height: 100%!important;
  background-size: cover!important;
  opacity: 1!important;
}
.card-content {
  z-index: 2!important;
}
.card-companyname {
  font-weight: bold;
  font-size: 14px;
  display: block;
  margin-bottom: 4px;
}

.card-profilename {
  font-size: 12px;
  display: block;
}

.card-align-bottom {
  position: absolute;
  bottom: 20px;
  width: calc(100% - 20px);
  left: 20px;
  right: 20px;
}

@media (max-width: 575.98px) {
  .kyano-card-mobile-small{
  transform: scale(0.5)!important;
  margin-bottom: -50px;
}

.kyano-card-small .card-companyname{
  font-size: 11px;
  margin-bottom: 0px;
}


.kyano-card-small .kyano-business-card.card-style-1 .card-type {
  font-size: 8px;
  text-align: right;
}

.kyano-card-small .card-profilename{
  font-size: 10px
}
.kyano-card-small .kyano-business-card.card-style-1{
  height: 110px;
  border-radius: 8px!important;
  padding: 25px;
}
.kyano-card-small .kyano-business-card.card-style-1 .card-nfc img{
  max-width: 20px;
  max-height: 20px;
  margin-left: auto
}
.kyano-card-small .kyano-business-card .col{
  padding: 0px!important;
}
.kyano-card-small .card-align-bottom {
  position: absolute;
  bottom: 25px;
  width: calc(100% - 25px);
  left: 25px;
  right: 25px;
}
}

</style>